"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const plugins_1 = require("../plugins");
class CursorController extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        this.controls = {
            transPick: { value: false, type: 'check', name: this.meta.translator + ".TRANSPICK" },
            // transTerrainPick: { value:false, type:'check', name: this.meta.translator + ".TRANSTERRAINPICK" },
            // cloudPick: { value:false, type:'check', name: this.meta.translator + ".CLOUDPICK" },
            // drillPick: { value:false, type:'check', name: this.meta.translator + ".DRILLPICK" },
            showMatrix: { value: false, type: 'check', name: this.meta.translator + ".SHOWMATRIX" },
            customMatrix: { value: false, type: 'check', name: this.meta.translator + ".CUSTOMMATRIX" },
            matrixSize: { value: 2, type: 'slider', min: 1, max: 10, step: 1, name: this.meta.translator + ".MATRIXSIZE", noshow: true },
        };
        this.measureHelper = null;
        this.mapService = null;
        this.preRenderListener = null;
    }
    itemInjected() {
        this.measureHelper = this.services.measureHelper;
        this.mapService = this.services.mapService;
        let me = this;
        let counter = 1000;
        // transfer state of pickers from the measureHelper
        this.controls.transPick.value = this.services.measureHelper.pickingTransparent;
        // this.controls.transTerrainPick.value = this.measureHelper.pickingTransparentTerrain;
        // this.controls.cloudPick.value = this.measureHelper.pickingPointclouds;
        this.preRenderListener = this.services.mapService.viewer.scene.preRender.addEventListener(function (scene) {
            if (counter++ > 5) {
                me.update();
                counter--;
            }
        });
        this.services.measureHelper.showDebug = true;
        this.refresh();
    }
    refresh() {
        // picking settings
        // this.measureHelper.pickingPointclouds = this.controls.cloudPick.value;
        this.services.measureHelper.pickingTransparent = this.controls.transPick.value;
        // this.measureHelper.pickingTransparentTerrain = this.controls.transTerrainPick.value;
        // enable translucent picking
        // this.mapService.viewer.scene.pickTranslucentDepth = this.controls.transPick.value;
        // debug stuff
        this.services.measureHelper.customMatrixSize = this.controls.matrixSize.value;
        // this.measureHelper.doDrillPick = this.controls.drillPick.value;
        this.services.measureHelper.showPickingMatrix = this.controls.showMatrix.value;
        if (this.controls.customMatrix.value) {
            this.services.measureHelper.pickingMatrix = 'custom';
            this.controls.matrixSize.noshow = false;
        }
        else {
            this.services.measureHelper.pickingMatrix = 'default';
            this.controls.matrixSize.noshow = true;
        }
    }
    update() {
        this.measureHelper.debugProps['picker.method'] = this.measureHelper.pickingMethod;
        this.measureHelper.debugProps['picker.pointClouds'] = this.measureHelper.pickingPointclouds;
        this.measureHelper.debugProps['picker.transparent'] = this.measureHelper.pickingTransparent;
        this.measureHelper.debugProps['picker.transparentTerrain'] = this.measureHelper.pickingTransparentTerrain;
        this.measureHelper.debugProps['picker.transparentGlobe'] = this.measureHelper.transparentPickGlobe;
        this.measureHelper.debugProps['scene.pickPositionSupported'] = this.mapService.viewer.scene.pickPositionSupported;
        this.measureHelper.debugProps['scene.useDepthPicking'] = this.mapService.viewer.scene.useDepthPicking;
        this.measureHelper.debugProps['scene.pickTranslucentDepth'] = this.mapService.viewer.scene.pickTranslucentDepth;
        // this.measureHelper.debugProps['scene.pickTranslucentDepth'] = this.mapService.viewer.scene.pickTranslucentDepth;
        this.measureHelper.debugProps['globe.translucency.enabled'] = this.mapService.viewer.scene.globe.translucency.enabled;
        this.measureHelper.debugProps['globe.depthTestAgainstTerrain'] = this.mapService.viewer.scene.globe.depthTestAgainstTerrain;
        this.measureHelper.debugProps['enableCollisionDetection'] = this.mapService.viewer.scene.screenSpaceCameraController.enableCollisionDetection;
        this.measureHelper.debugProps['scene.light'] = this.mapService.viewer.scene.light.constructor.name;
        this.measureHelper.debugProps['shadows'] = this.mapService.viewer.shadows;
        this.measureHelper.debugProps['globe.enableLighting'] = this.mapService.viewer.scene.globe.enableLighting;
        this.measureHelper.debugProps['globe.dynamicAtmosphereLighting'] = this.mapService.viewer.scene.globe.dynamicAtmosphereLighting;
        this.measureHelper.debugProps['globe.dynamicAtmosphereLightingFromSun'] = this.mapService.viewer.scene.globe.dynamicAtmosphereLightingFromSun;
        this.measureHelper.debugProps['clock.currentTime'] = this.mapService.viewer.clock.currentTime;
        let items = this.services.sceneController.transparentItems;
        Object.keys(items).forEach(key => {
            this.measureHelper.debugProps['transItem-' + key] = items[key];
        });
        const debuglist = [];
        for (let n = 1; n < 5; n++) {
            this.measureHelper.debugProps['picked_' + n] = '';
        }
        if (this.measureHelper.pickedModel) {
            debuglist.push(this.createProp('picked', this.measureHelper.pickedModel));
        }
        if (this.measureHelper.pickedModels && this.measureHelper.pickedModels.length) {
            let count = 1;
            this.measureHelper.pickedModels.forEach(item => {
                debuglist.push(this.createProp('picked_' + count++, item));
            });
        }
        if (this.measureHelper.pickedModels) {
            this.measureHelper.debugProps['picked_items'] = this.measureHelper.pickedModels.length + ' (' + debuglist.length + ')';
        }
        else {
            this.measureHelper.debugProps['picked_items'] = 0 + ' (' + debuglist.length + ')';
        }
        debuglist.forEach(item => {
            this.measureHelper.debugProps[item.key] = item.value;
        });
        // this.measureHelper.debugProps['counters'] = 'render=['+this.measureHelper.countRender+'] mouseCalls=['+this.measureHelper.countMouseCalls+'] mouseActions=['+this.measureHelper.countMouseAction+']';
    }
    createProp(key, item) {
        let type = 'object';
        let id = '.';
        let tid = '.';
        let name = '.';
        if (item['primitive']) {
            id = item.primitive['id'];
            if (item.primitive['transform_id']) {
                tid = item.primitive['transform_id'];
            }
            if (item.primitive['name']) {
                name = item.primitive['name'];
            }
        }
        if (item['content']) {
            type = item.content.constructor.name;
        }
        if (item['id']) {
            type = item.id.constructor.name;
            id = item.id.id;
            if (item.id['_name']) {
                name = item.id['_name'];
            }
        }
        if (item['_batchId']) {
            id = item['_batchId'];
        }
        return { key: key, value: type + ' name=[' + name + '] id=[' + id + '] t=[' + tid + ']' };
    }
    end() {
        this.mapService.viewer.scene.preRender.removeEventListener(this.preRenderListener);
        this.preRenderListener = null;
        this.measureHelper.showDebug = false;
    }
}
CursorController.meta = {
    label: 'PLUGINS.CURSOR_CONTROLLER.LABEL',
    name: 'cursor-controller',
    translator: 'PLUGINS.CURSOR_CONTROLLER',
    tooltip: 'PLUGINS.CURSOR_CONTROLLER.TOOLTIP',
    shortcut: true,
    icon: 'mouse-pointer',
    category: plugins_1.FdmPlugin.category.debug,
    types: [plugins_1.FdmPlugin.types.sceneController],
    cardinality: plugins_1.FdmPlugin.cardinality.one,
};
exports.CursorController = CursorController;
